import createAxiosConfig from "../config/createAxiosConfig";
import store from "../config/store";
import StorageHelper from "../helpers/StorageHelper";

const storageHelper = new StorageHelper();
const headers = {
  "Content-Type": "application/json",
};
const axiosConfig = createAxiosConfig(store.baseUrl, headers);

class PuxaPlacaApiRepository {
  constructor(url) {
    this.url = url;
  }

  async get() {
    const token = storageHelper.getLocal("token");
    return axiosConfig
      .get(this.url, {
        timeout: 30000,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      })
      .then(function (reponse) {
        return reponse;
      })
      .catch(function (erro) {
        return erro;
      });
  }
}

export default PuxaPlacaApiRepository;
